var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._b({attrs:{"label":"File input","dense":"","outlined":"","chips":""},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"focus":function($event){return _vm.$emit('focus', $event)}}},'v-file-input',{ ..._vm.$attrs, ..._vm.$props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }